import { createContainer } from 'react-sweet-state';

import { PageStore } from './PageStore';

export const PageStoreContainer = createContainer(PageStore);
